<div class="form-panel-container">
    <form [formGroup]="formGroup">
        <div class="form-container" [ngClass]="{ readonly: _context?.mode === FormMode.Reading }">
            <div class="form-item form-item-help">
                <mat-form-field class="with-info-icon">
                    <mat-label>Nom</mat-label>
                    <input matInput data-input-name type="text" formControlName="name" autocomplete="off" required />
                    @if (formGroupErrors?.name?.required && (formGroup.controls['name']?.dirty || formGroup.controls['name'].touched)) {
                        <mat-error data-input-title-error>Le champ 'Nom' est obligatoire</mat-error>
                    }
                </mat-form-field>
                <fa-icon [icon]="faCircleInfo" class="info-icon" matTooltip="TODO Nom" matTooltipPosition="right"></fa-icon>
            </div>

            <div class="form-item form-item-help">
                <mat-form-field class="with-info-icon">
                    <mat-label>Bannette par défaut</mat-label>
                    <mat-select data-select-defaultBoxId formControlName="defaultBoxId" required>
                        @for (box of _context.boxes; track box) {
                            <mat-option data-select-listing-type-option [value]="box.id">{{ box.displayName }}</mat-option>
                        }
                    </mat-select>
                    @if (formGroupErrors?.defaultBoxId?.required && (formGroup.controls['defaultBoxId']?.dirty || formGroup.controls['defaultBoxId'].touched)) {
                        <mat-error data-input-title-error>Le champ 'bannette par défaut' est obligatoire</mat-error>
                    }
                </mat-form-field>
                <fa-icon [icon]="faCircleInfo" class="info-icon" matTooltip="TODO Bannette par défaut" matTooltipPosition="right"></fa-icon>
            </div>
        </div>
    </form>
    <div class="buttons-container">
        <button mat-stroked-button class="accent-button" [disabled]="formGroup.disabled" [ngClass]="{ disabled: formGroup.invalid || formGroup.disabled }" (click)="cancel()">
            Annuler
        </button>
        <button
            mat-raised-button
            class="accent-button"
            [disabled]="formGroup.disabled || formGroup.invalid"
            [ngClass]="{ disabled: formGroup.invalid || formGroup.disabled }"
            (click)="manualSave()">
            Enregistrer
        </button>
    </div>
</div>
